module.exports = __webpack_public_path__ + "static/media/antonio_wellington.710a6e00.png";